import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { HYDRATE } from 'next-redux-wrapper';
import { fetchGetSeoData } from '../services/fetch-get-seo-data';
import { seoDataType, SeoSchema } from '../types/seoSchema';
import { seoMockDataAuto } from '@entities/Seo/module/services/mock-data';

const initialState: SeoSchema = {
  seoData: null,
  ssrSeoData: null,
};

export const seoSlice = createSlice({
  name: 'seo',
  initialState,
  reducers: {
    setSeoData: (state, action: PayloadAction<seoDataType>) => {
      state.seoData = action.payload;
    },
  },
  extraReducers: builder => {
    builder.addCase(HYDRATE, (state, action: any) => {
      return {
        ...state,
        ...action.payload.seo,
      };
    });
    builder.addCase(fetchGetSeoData.fulfilled, (state, action) => {
      if (action.payload) {
        state.seoData = action.payload;
        state.ssrSeoData = action.payload;
      } else {
        state.seoData = seoMockDataAuto;
        state.ssrSeoData = seoMockDataAuto;
      }
    });
  },
});

export const { actions: seoActions } = seoSlice;
